(function() {
	'use strict';
	angular.module('crewProfile').controller('crewFlyingHoursRangePopupCtrl',
			crewFlyingHoursRangePopupCtrl);

	function crewFlyingHoursRangePopupCtrl($uibModalInstance, modalParams,
			MessageService, EventManagerService, PopupManager) {
		var vm = this;

		vm.model = { 
			rangeDetails : modalParams
		};

		vm.onCloseClick = function() {
			PopupManager.closeModal('ADD_CREW_FLYING_HOURS_RANGE');
		};

		vm.onDeleteRange = function() {
			EventManagerService.notifyEventListeners(
					EventManagerService.EVENT.CREW_PAYMENT_RATES.DELETE_RANGE,
					vm.model.rangeDetails);
		}

		vm.onApplyAddRangeData = function() {
			if (isValidAddRangeParams()) {
				EventManagerService.notifyEventListeners(
						EventManagerService.EVENT.CREW_PAYMENT_RATES.APPLY_RANGE,
						vm.model.rangeDetails);
			} else {
				MessageService
						.warning(MessageService.MESSAGES.PAYMENT_RATES.POPUP_FORM_ERROR);
			}
		}
		
		function isValidAddRangeParams(){
			if(!!vm.model.rangeDetails.rangeTitle
					&& (!!vm.model.rangeDetails.rangeStartHour || vm.model.rangeDetails.rangeStartHour == 0)
					&& (vm.model.rangeDetails.flyHourRate || vm.model.rangeDetails.flyHourRate == 0)){
				return true;
			}
			return false;
		}

		vm.closeMe = function() {
			$uibModalInstance.close();
		};
	}
}());
